/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropInWatchTrendPoint } from './DropInWatchTrendPoint';
import {
    DropInWatchTrendPointFromJSON,
    DropInWatchTrendPointFromJSONTyped,
    DropInWatchTrendPointToJSON,
    DropInWatchTrendPointToJSONTyped,
} from './DropInWatchTrendPoint';
import type { DropInWatchSummary } from './DropInWatchSummary';
import {
    DropInWatchSummaryFromJSON,
    DropInWatchSummaryFromJSONTyped,
    DropInWatchSummaryToJSON,
    DropInWatchSummaryToJSONTyped,
} from './DropInWatchSummary';
import type { DropInMostWatched } from './DropInMostWatched';
import {
    DropInMostWatchedFromJSON,
    DropInMostWatchedFromJSONTyped,
    DropInMostWatchedToJSON,
    DropInMostWatchedToJSONTyped,
} from './DropInMostWatched';
import type { DropInTopDrop } from './DropInTopDrop';
import {
    DropInTopDropFromJSON,
    DropInTopDropFromJSONTyped,
    DropInTopDropToJSON,
    DropInTopDropToJSONTyped,
} from './DropInTopDrop';
import type { DropInPlatformBreakdown } from './DropInPlatformBreakdown';
import {
    DropInPlatformBreakdownFromJSON,
    DropInPlatformBreakdownFromJSONTyped,
    DropInPlatformBreakdownToJSON,
    DropInPlatformBreakdownToJSONTyped,
} from './DropInPlatformBreakdown';
import type { DropInEngagementTrendPoint } from './DropInEngagementTrendPoint';
import {
    DropInEngagementTrendPointFromJSON,
    DropInEngagementTrendPointFromJSONTyped,
    DropInEngagementTrendPointToJSON,
    DropInEngagementTrendPointToJSONTyped,
} from './DropInEngagementTrendPoint';
import type { DropInEngagementSummary } from './DropInEngagementSummary';
import {
    DropInEngagementSummaryFromJSON,
    DropInEngagementSummaryFromJSONTyped,
    DropInEngagementSummaryToJSON,
    DropInEngagementSummaryToJSONTyped,
} from './DropInEngagementSummary';

/**
 * 
 * @export
 * @interface DropInAnalyticsResponse
 */
export interface DropInAnalyticsResponse {
    /**
     * 
     * @type {string}
     * @memberof DropInAnalyticsResponse
     */
    timeFilter: string;
    /**
     * ISO date string (YYYY-MM-DD)
     * @type {string}
     * @memberof DropInAnalyticsResponse
     */
    startDate: string;
    /**
     * ISO date string (YYYY-MM-DD)
     * @type {string}
     * @memberof DropInAnalyticsResponse
     */
    endDate: string;
    /**
     * ISO date of the earliest tracked drop event. Null if no data yet.
     * @type {string}
     * @memberof DropInAnalyticsResponse
     */
    metricsAvailableFrom: string | null;
    /**
     * 
     * @type {DropInEngagementSummary}
     * @memberof DropInAnalyticsResponse
     */
    engagement: DropInEngagementSummary;
    /**
     * 
     * @type {DropInWatchSummary}
     * @memberof DropInAnalyticsResponse
     */
    watchTime: DropInWatchSummary;
    /**
     * 
     * @type {Array<DropInPlatformBreakdown>}
     * @memberof DropInAnalyticsResponse
     */
    platformBreakdown: Array<DropInPlatformBreakdown>;
    /**
     * 
     * @type {Array<DropInMostWatched>}
     * @memberof DropInAnalyticsResponse
     */
    mostWatchedDrops: Array<DropInMostWatched>;
    /**
     * 
     * @type {Array<DropInTopDrop>}
     * @memberof DropInAnalyticsResponse
     */
    topDropsByImpressions: Array<DropInTopDrop>;
    /**
     * 
     * @type {Array<DropInWatchTrendPoint>}
     * @memberof DropInAnalyticsResponse
     */
    watchTrend: Array<DropInWatchTrendPoint>;
    /**
     * 
     * @type {Array<DropInEngagementTrendPoint>}
     * @memberof DropInAnalyticsResponse
     */
    engagementTrend: Array<DropInEngagementTrendPoint>;
    /**
     * 
     * @type {number}
     * @memberof DropInAnalyticsResponse
     */
    computedAt: number;
}

/**
 * Check if a given object implements the DropInAnalyticsResponse interface.
 */
export function instanceOfDropInAnalyticsResponse(value: object): value is DropInAnalyticsResponse {
    if (!('timeFilter' in value) || value['timeFilter'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('metricsAvailableFrom' in value) || value['metricsAvailableFrom'] === undefined) return false;
    if (!('engagement' in value) || value['engagement'] === undefined) return false;
    if (!('watchTime' in value) || value['watchTime'] === undefined) return false;
    if (!('platformBreakdown' in value) || value['platformBreakdown'] === undefined) return false;
    if (!('mostWatchedDrops' in value) || value['mostWatchedDrops'] === undefined) return false;
    if (!('topDropsByImpressions' in value) || value['topDropsByImpressions'] === undefined) return false;
    if (!('watchTrend' in value) || value['watchTrend'] === undefined) return false;
    if (!('engagementTrend' in value) || value['engagementTrend'] === undefined) return false;
    if (!('computedAt' in value) || value['computedAt'] === undefined) return false;
    return true;
}

export function DropInAnalyticsResponseFromJSON(json: any): DropInAnalyticsResponse {
    return DropInAnalyticsResponseFromJSONTyped(json, false);
}

export function DropInAnalyticsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropInAnalyticsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'timeFilter': json['timeFilter'],
        'startDate': json['startDate'],
        'endDate': json['endDate'],
        'metricsAvailableFrom': json['metricsAvailableFrom'],
        'engagement': DropInEngagementSummaryFromJSON(json['engagement']),
        'watchTime': DropInWatchSummaryFromJSON(json['watchTime']),
        'platformBreakdown': ((json['platformBreakdown'] as Array<any>).map(DropInPlatformBreakdownFromJSON)),
        'mostWatchedDrops': ((json['mostWatchedDrops'] as Array<any>).map(DropInMostWatchedFromJSON)),
        'topDropsByImpressions': ((json['topDropsByImpressions'] as Array<any>).map(DropInTopDropFromJSON)),
        'watchTrend': ((json['watchTrend'] as Array<any>).map(DropInWatchTrendPointFromJSON)),
        'engagementTrend': ((json['engagementTrend'] as Array<any>).map(DropInEngagementTrendPointFromJSON)),
        'computedAt': json['computedAt'],
    };
}

export function DropInAnalyticsResponseToJSON(json: any): DropInAnalyticsResponse {
    return DropInAnalyticsResponseToJSONTyped(json, false);
}

export function DropInAnalyticsResponseToJSONTyped(value?: DropInAnalyticsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timeFilter': value['timeFilter'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'metricsAvailableFrom': value['metricsAvailableFrom'],
        'engagement': DropInEngagementSummaryToJSON(value['engagement']),
        'watchTime': DropInWatchSummaryToJSON(value['watchTime']),
        'platformBreakdown': ((value['platformBreakdown'] as Array<any>).map(DropInPlatformBreakdownToJSON)),
        'mostWatchedDrops': ((value['mostWatchedDrops'] as Array<any>).map(DropInMostWatchedToJSON)),
        'topDropsByImpressions': ((value['topDropsByImpressions'] as Array<any>).map(DropInTopDropToJSON)),
        'watchTrend': ((value['watchTrend'] as Array<any>).map(DropInWatchTrendPointToJSON)),
        'engagementTrend': ((value['engagementTrend'] as Array<any>).map(DropInEngagementTrendPointToJSON)),
        'computedAt': value['computedAt'],
    };
}

